import { Box, VBox } from "../components-v2/Box";
import dCompanyLogo from "../assets/img/brand/dcompany_logo.svg";
import { dcompanyFrontpageUrl } from "../utils/navigation";
import { LinkButton } from "../components-v2/Button";
import { FullScreenLayout } from "../components-v2/FullScreenLayout";
import { useRootStore, useTranslation } from "../stores/RootStoreContext";

const BankIdLoginSweden = () => {
  const history = useRootStore().history;
  const { t } = useTranslation();
  return (
    <FullScreenLayout
      pageHeader={
        <Box padding>
          <Logo />
        </Box>
      }
      centerPanel={
        <VBox container maxWidth={"sm"} gap={"md"}>
          <h3>{t("login.swedish-bankid-header")}</h3>
          <Box bg>
            <iframe src={"/api/auth/bankid-sweden"} height={"425"} width={"400"} />
          </Box>
          <div>
            <LinkButton label={t("cancel")} onClick={history.goBack} icon={"arrow-left"} />
          </div>
        </VBox>
      }
    />
  );
};

const Logo = () => {
  const { lang } = useTranslation();
  return (
    <div>
      <a href={dcompanyFrontpageUrl(lang)}>
        <img src={dCompanyLogo} alt="dCompany logo" style={{ maxWidth: 200 }} />
      </a>
    </div>
  );
};

export default BankIdLoginSweden;
